import { LI as ExpoLI, UL as ExpoUL } from '@expo/html-elements';
import { ComponentProps } from 'react';
import { View } from 'react-native';
import { twMerge } from 'tailwind-merge';

import { Text } from '@/components/ui/text';

type ULProps = ComponentProps<typeof ExpoUL>;

/**
 * Cross-platform bulleted list primitives.
 *
 * Wraps UL/LI from @expo/html-elements (following the same pattern as the
 * Heading component) so consumers get correct list/listitem ARIA roles on
 * web while keeping NativeWind styling. The bullet is rendered as a sized
 * View rather than a glyph so it visually matches CSS `list-style: disc`
 * — the Unicode `•` character is a small punctuation glyph and renders
 * noticeably smaller than what designers expect from a "bullet."
 */
export function UL({ className, ...props }: ULProps) {
  return <ExpoUL className={twMerge('pl-4', className)} {...props} />;
}

type LIProps = {
  children: string;
  className?: string;
};

export function LI({ children, className }: LIProps) {
  return (
    <ExpoLI className={twMerge('flex-row items-start', className)}>
      <View
        testID="bullet-dot"
        className="mr-2 mt-[7px] h-1.5 w-1.5 rounded-full bg-typography-900"
      />
      <Text className="flex-1 text-sm leading-[1.4] text-typography-900">{children}</Text>
    </ExpoLI>
  );
}
